import React from 'react';
import { PhoneOff, UserCheck, AlertTriangle, Clock, MessageSquare, Mic } from 'lucide-react';

export default function VoiceCallCard({ call, onHandoff }) {
  const strikeColor =
    call.strikes >= 3 ? 'bg-red-100 text-red-700 border-red-200' :
    call.strikes >= 2 ? 'bg-amber-100 text-amber-700 border-amber-200' :
                        'bg-emerald-100 text-emerald-700 border-emerald-200';

  return (
    <div className={`bg-white/90 backdrop-blur-sm border rounded-2xl shadow-lg overflow-hidden transition-all
      ${call.strikes >= 3 ? 'border-red-300 shadow-red-100' :
        call.strikes >= 2 ? 'border-amber-300 shadow-amber-100' :
                            'border-slate-200/60'}`}>

      {/* Header */}
      <div className="px-6 py-4 flex items-center justify-between border-b border-slate-100">
        <div className="flex items-center gap-4">
          <div className={`w-11 h-11 rounded-xl flex items-center justify-center font-bold text-base shadow-sm
            ${call.strikes >= 3 ? 'bg-red-100 text-red-700' :
              call.strikes >= 2 ? 'bg-amber-100 text-amber-700' :
                                  'bg-gradient-to-br from-blue-100 to-emerald-50 text-blue-700'}`}>
            {(call.candidate_name || call.candidatename || 'U').charAt(0).toUpperCase()}
          </div>
          <div>
            <p className="text-sm font-bold text-slate-900">{call.candidate_name || call.candidatename || 'Unknown Candidate'}</p>
            <p className="text-xs text-slate-500 mt-0.5">{call.job_title || call.jobtitle || 'Unknown Role'}</p>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <span className="flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-emerald-50 border border-emerald-200 text-emerald-700 text-xs font-bold">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" />
            LIVE
          </span>
          <span className="flex items-center gap-1.5 px-2.5 py-1 rounded-full border border-slate-200 bg-white text-slate-600 text-xs font-bold">
            <Clock className="w-3 h-3" /> {call.duration}m
          </span>
          <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-bold border ${strikeColor}`}>
            {call.strikes >= 3 && <AlertTriangle className="w-3 h-3 mr-1" />}
            {call.strikes}/3 Strikes
          </span>
        </div>
      </div>

      {/* Strike progress bar */}
      <div className="px-6 pt-3 pb-1">
        <div className="flex gap-1.5">
          {[0, 1, 2].map(i => (
            <div key={i} className={`h-1.5 flex-1 rounded-full transition-all ${
              i < call.strikes
                ? call.strikes >= 3 ? 'bg-red-500' : call.strikes >= 2 ? 'bg-amber-500' : 'bg-emerald-500'
                : 'bg-slate-100'}`} />
          ))}
        </div>
      </div>

      {/* Transcript preview */}
      {(call.transcript_preview || call.transcriptpreview) && (
        <div className="mx-6 my-3 flex items-start gap-2.5 px-4 py-3 bg-slate-50/80 rounded-xl border border-slate-100">
          <MessageSquare className="w-4 h-4 text-slate-400 flex-shrink-0 mt-0.5" />
          <p className="text-xs text-slate-600 line-clamp-2 leading-relaxed">
            "{call.transcript_preview || call.transcriptpreview}…"
          </p>
        </div>
      )}

      {/* Actions */}
      <div className="px-6 py-4 flex items-center justify-end gap-2">
        <button className="inline-flex items-center gap-1.5 px-4 py-2.5 rounded-xl bg-slate-50 text-slate-600 hover:bg-slate-100 font-semibold text-sm transition-colors border border-slate-200">
          <Mic className="w-3.5 h-3.5" /> Mute
        </button>

        {(call.handoff_available || call.handoffavailable) ? (
          <button
            onClick={() => onHandoff(call.call_session_id || call.callsessionid)}
            className="inline-flex items-center gap-1.5 px-4 py-2.5 rounded-xl bg-gradient-to-r from-red-500 to-rose-600 text-white font-bold text-sm shadow-md hover:shadow-lg hover:scale-[1.02] active:scale-[0.98] transition-all"
          >
            <UserCheck className="w-4 h-4" /> Human Handoff
          </button>
        ) : (
          <button disabled className="inline-flex items-center gap-1.5 px-4 py-2.5 rounded-xl bg-slate-100 text-slate-400 font-semibold text-sm cursor-not-allowed">
            <PhoneOff className="w-3.5 h-3.5" /> Handoff (2+ strikes)
          </button>
        )}
      </div>
    </div>
  );
}
